// extracted by mini-css-extract-plugin
module.exports = {"restaurant-menu":"style_restaurant-menu__3Fqyr","form-group":"style_form-group__11F9g"};